import React from 'react';
import { Field } from 'formik';

export default ({
  name,
  inputType,
  placeholder,
  maxLength,
  type,
  floating = true,
  showErrorMessages = true,
  disabled,
  value,
  onChange,
  blurHandler,
  changeHandler = () => { }
}) => {
  if (name === "businessUrl") {
    maxLength = 200
  } else if (name === 'email') {
    maxLength = 100
  } else {
    if (maxLength === undefined) {
      maxLength = 50
    }
  }

  return (
    <Field name={name}>
      {({ field, meta, form }) => {
        if (type === undefined) {
          type = 'text';
        }
        if (disabled === undefined) disabled = false;

        return (
          <div className='app-input-text text-input-styles'>
            <input
              className={`${meta.touched && meta.error ? 'error' : ''}`}
              name={field.name}
              placeholder={placeholder}
              type={type}
              // autocomplete="off"
              value={field.value || ''}
              maxLength={maxLength}
              disabled={disabled}
              onKeyUp={(evt) => {
                if (name === "email") {
                  if (evt.target.value === localStorage.getItem('email')) {
                    form.setFieldValue("password", localStorage.getItem('password'))
                  }
                }
                if (inputType === "text" && name !== "accountHolderName") {
                  const setValue = evt.target.value.replace(/[^a-zA-Z\s]/g, '')
                  let firstLetterCap = setValue.charAt(0).toUpperCase() + setValue.slice(1)
                  form.setFieldValue(name, firstLetterCap)
                } else if (inputType === "textAndNumber") {
                  const setValue = evt.target.value.replace(/[^0-9a-zA-Z\s]/g, '')
                  let firstLetterCap = setValue.charAt(0).toUpperCase() + setValue.slice(1)
                  form.setFieldValue(name, firstLetterCap)
                } else if (inputType === "companyText") {
                  const setValue = evt.target.value.replace(/[^a-zA-Z0-9,.\-& ]/g, '')
                  let firstLetterCap = setValue.charAt(0).toUpperCase() + setValue.slice(1)
                  form.setFieldValue(name, firstLetterCap)
                } else if (name === "accountHolderName") {
                  const setValue = evt.target.value;
                  const sanitizedValue = setValue.replace(/[^A-Za-z0-9&,.\- ]/g, ''); // Allow letters, numbers, &, , . - and spaces
                  const containsLettersOrNumbers = /[A-Za-z0-9]/.test(sanitizedValue);
                  if (containsLettersOrNumbers) {
                    const words = sanitizedValue.split(/\s+/); // Capitalize the first letter of each word (only affects words starting with a letter)
                    const capitalizedWords = words.map(word =>
                      word.charAt(0).toUpperCase() + word.slice(1)
                    );
                    const formattedValue = capitalizedWords.join(' ');
                    form.setFieldValue(name, formattedValue);
                  } else {
                    form.setFieldValue(name, '');
                  }
                }
                else if (inputType === "addressText") {
                  const setValue = evt.target.value.replace(/[^0-9a-zA-Z- #''\s]/g, '')
                  let firstLetterCap = setValue.charAt(0).toUpperCase() + setValue.slice(1)
                  form.setFieldValue(name, firstLetterCap)
                } else if (inputType === "ptPlusAdminRegisterLocationName") {
                  const setValue = evt.target.value?.replaceAll(",", "")
                  let firstLetterCap = setValue.charAt(0).toUpperCase() + setValue.slice(1)
                  form.setFieldValue(name, firstLetterCap)
                  form.setFieldValue('selectLocation', firstLetterCap)
                } else if (inputType === "companyAndLocationText") {
                  const setValue = evt.target.value?.replaceAll(",", "")
                  let firstLetterCap = setValue.charAt(0).toUpperCase() + setValue.slice(1)
                  form.setFieldValue(name, firstLetterCap)
                } else if (inputType === undefined && name !== "businessUrl") {
                  const setValue = evt.target.value
                  form.setFieldValue(name, setValue)
                  changeHandler(evt.target.value)
                } else if (name === "businessUrl") {
                  const setValue = evt.target.value
                  form.setFieldValue(name, setValue)
                } else if (inputType === "checkoutPagePromoCode") {
                  const removeSpace = evt.target.value.replace(/ /g, '')
                  form.setFieldValue(name, removeSpace)
                  changeHandler(evt.target.value)
                } else {
                  if (name !== "description" && name !== "email" && name !== "billToEmail" && name !== "addUserEmail" && name !== "personnelTypeEmail" && name !== "promoCodeInput" && name !== "password" && name !== "confirmPassword") {
                    let firstLetterCap = evt.target.value.charAt(0).toUpperCase() + evt.target.value.slice(1)
                    form.setFieldValue(name, firstLetterCap)
                  }
                }
                if (name === "email") {
                  const removeSpace = evt.target.value.replace(/ /g, '')
                  form.setFieldValue(name, removeSpace)
                  changeHandler(evt.target.value)
                }
                if (name === "promoCodeInput") {
                  const removeSpace = evt.target.value.replace(/ /g, '')
                  form.setFieldValue(name, removeSpace)
                }
              }}
              onBlurCapture={() => {
                blurHandler && blurHandler(field.value)
              }}
              onChange={(evt) => {
              }}
              {...field}
            />
            {meta.touched && meta.error && showErrorMessages && (
              <p name={name + 'Error'} className='error-message'>{meta.error}</p>
            )}
          </div>
        );
      }}
    </Field>
  );
}